export const state = {
  cachedMenu: [
    {
      title: '新訊/活動分類',
      alias: 'news-list',
      children: [
        {
          title: '新訊/活動項目',
          alias: 'news-item',
        },
      ]
    },
    {
      title: '解決方案',
      alias: 'solution-list',
      children: [
        {
          title: '解決方案項目',
          alias: 'solution-item',
        },
      ]
    },
    {
      title: '微軟原⽣解決⽅案',
      alias: 'resource-list',
      children: [
        {
          title: '微軟原⽣解決⽅案項目',
          alias: 'resource-item',
        },
      ]
    },
  ],
};

export const getters = {};

export const mutations = {
  CACHE_MENU(state, menu) {
    state.cachedMenu = menu
  },
};

export const actions = {
  updateMenu({
    commit
  }, menu = {}) {
    commit('CACHE_MENU', menu)
  },
};
